import {Configuration, type ProfileAvailability, PublicUpdateAvailabilityApi} from '@api';

// TODO: rename this function as it's not a composable
// eslint-disable-next-line @malt/consistent-composable-naming
export function useUpdateAvailabilityApi(profileId: string, token: string) {
    const apiConfiguration = new Configuration({basePath: ''});
    const updateAvailabilityApi = new PublicUpdateAvailabilityApi(apiConfiguration);

    async function getAvailability(): Promise<ProfileAvailability> {
        return await updateAvailabilityApi.getAvailability({
            profileId,
            token,
        });
    }

    async function confirmAvailable(): Promise<ProfileAvailability> {
        return await updateAvailabilityApi.confirmAvailabilityDetails({
            profileId,
            token,
            confirmAvailabilityDetailsRequest: {
                available: true,
            },
        });
    }

    async function confirmNotAvailable(nextAvailabilityDate: Date): Promise<ProfileAvailability> {
        return await updateAvailabilityApi.confirmAvailabilityDetails({
            profileId,
            token,
            confirmAvailabilityDetailsRequest: {
                available: false,
                nextAvailabilityDate,
            },
        });
    }

    return {
        getAvailability,
        confirmAvailable,
        confirmNotAvailable,
    };
}
